import { PlaySVG } from "../../svg"

import styles from "./streamCard.module.scss"
import RouterLink from "../link/RouterLink"
import { FormattedMessage } from "react-intl"

function StreamCard({image, alt, imageTitle, title, buttonLink }) {
  return (
    <article className={styles.streamcard}>
      <div className={styles.image}>
        <RouterLink href={buttonLink}>
          {image ? (
            <picture>
              <img src={image} alt={alt || imageTitle} width={160} height={90} />
            </picture>
          ) : null}
        </RouterLink>
      </div>
      <div className={styles.content}>
        <RouterLink className={styles.title} href={buttonLink}>{title}</RouterLink>
        <RouterLink className={`btn btn-cr-orange ${styles.btn}`} href={buttonLink}>
          <PlaySVG />
            <FormattedMessage id="stream_card.start_watching"/>
        </RouterLink>
      </div>
    </article>
  )
}

export default StreamCard
